module.exports = __webpack_public_path__ + "fonts/Inter-900-latin-ext83.2685934.woff2";